<template>
  <v-container fluid>
    <h1 class="display-inline">Keywords Report</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <v-row>
      <v-col cols="12">
        <JobsKeywordReport></JobsKeywordReport>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import JobsKeywordReport from "@/components/jobs/JobsKeywordReport.vue";
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "JobsAuditReportPage",
  permissions: [...JobsKeywordReport.permissions],
  components: {
    ActiveApiCalls,
    JobsKeywordReport,
  },
  methods: {},
  mounted() {
  },
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>